import React from 'react';
import './Loading.css';
var Loading = function () { return (React.createElement("section", { className: "backdrop", id: "loading" },
    React.createElement("div", { className: "loading" }))); };
export default Loading;
